import PaywallContent, { PaywallContentProps } from './PaywallContent'
import { FeatureFlags } from '@dupe/common/constants'
import { PostHogFeature } from 'posthog-js/react'
import { useEffect, useState } from 'react'
import {
  Drawer,
  DrawerContent,
  DrawerTrigger,
} from '~/src/components/ui/drawer'

export interface PaywallDrawerProps extends PaywallContentProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  children?: React.ReactNode
}

const PaywallDrawer: React.FC<PaywallDrawerProps> = ({
  isOpen,
  onOpenChange,
  onSuccess,
  onCancel,
  source = 'drawer',
  featureName,
  children,
}) => {
  const [open, setOpen] = useState(isOpen)

  // Sync internal state with external handler
  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen)
    onOpenChange(newOpen)
  }

  // Handle cancel button click
  const handleCancel = () => {
    handleOpenChange(false)
    if (onCancel) {
      onCancel()
    }
  }

  // Handle successful subscription
  const handleSuccess = () => {
    handleOpenChange(false)
    if (onSuccess) {
      onSuccess()
    }
  }

  // Handle external open state changes
  useEffect(() => {
    setOpen(isOpen)
  }, [isOpen])

  return (
    <PostHogFeature flag={FeatureFlags.PaywallDrawer} match={true}>
      <Drawer open={open} onOpenChange={handleOpenChange}>
        {children && <DrawerTrigger asChild>{children}</DrawerTrigger>}
        <DrawerContent className='bg-white text-black'>
          <PaywallContent
            onSuccess={handleSuccess}
            onCancel={handleCancel}
            source={source}
            featureName={featureName}
          />
        </DrawerContent>
      </Drawer>
    </PostHogFeature>
  )
}

export default PaywallDrawer
